module.exports = __webpack_public_path__ + "static/media/squared.06d2bd74.jpg";